import { AfterViewInit, Directive, ElementRef, NgZone, OnDestroy, Renderer2 } from '@angular/core';
import { CdkObserveContent, ContentObserver } from '@angular/cdk/observers';
import { fromEvent, merge, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { createResizeObservable } from '../util/rxjs-util';



@Directive({
  selector: '[appScrollableTable]'
})
export class ScrollableTableDirective implements AfterViewInit, OnDestroy {
  private observeContent: CdkObserveContent;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private ngZone: NgZone,
    private renderer: Renderer2,
    private elementRef: ElementRef<HTMLElement>,
    private contentObserver: ContentObserver
  ) {
    this.init();
  }

  ngAfterViewInit(): void {
    this.detectScrollPosition();
  }

  ngOnDestroy(): void {
    this.observeContent.ngOnDestroy();
    this.subscriptions.unsubscribe();
  }

  detectScrollPosition(): void {
    const element = this.elementRef.nativeElement;
    const scrollableGap = element.scrollWidth - element.clientWidth;

    if (element.scrollLeft > 0) {
      this.renderer.addClass(element, 'scrollable-left');
    } else {
      this.renderer.removeClass(element, 'scrollable-left');
    }
    if (element.scrollLeft < scrollableGap) {
      this.renderer.addClass(element, 'scrollable-right');
    } else {
      this.renderer.removeClass(element, 'scrollable-right');
    }
  }

  private init(): void {
    this.observeContent = new CdkObserveContent(this.contentObserver, this.elementRef, this.ngZone);

    this.subscriptions.add(
      this.observeContent.event
        .pipe(
          debounceTime(10)
        )
        .subscribe(() => {
          this.detectScrollPosition();
        })
    );

    this.observeContent.ngAfterContentInit();

    this.subscriptions.add(
      merge(
        fromEvent(this.elementRef.nativeElement, 'scroll'),
        createResizeObservable(this.elementRef.nativeElement)
      )
        .pipe(
          debounceTime(10)
        )
        .subscribe(() => {
          this.detectScrollPosition();
        })
    );
  }
}
